/**
 * Currency Selector Component
 * Handles currency/country selection in the header
 */

// Custom element approach
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="country_code"]');
        this.label = this.querySelector('.header__currency-label');

        // Add click handlers to all currency option buttons
        this.querySelectorAll('.header__currency-option').forEach((button) => {
          button.addEventListener('click', this.onCurrencyClick.bind(this));
        });
      }

      onCurrencyClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const countryCode = button.dataset.value;
        const currencyCode = button.dataset.currency;

        if (!countryCode) return;

        console.log('Currency clicked:', currencyCode, countryCode);

        // Update hidden input
        if (this.input) {
          this.input.value = countryCode;
        }

        // Update label with selected currency
        if (this.label && currencyCode) {
          this.label.textContent = currencyCode;
        }

        // Remove active class from all buttons
        this.querySelectorAll('.header__currency-option').forEach((btn) => {
          btn.classList.remove('active');
        });

        // Add active class to clicked button
        button.classList.add('active');

        // Submit the form
        if (this.form) {
          this.form.submit();
        }
      }
    }
  );
}

// Fallback: Direct event listeners (in case custom elements don't work)
document.addEventListener('DOMContentLoaded', () => {
  const currencyOptions = document.querySelectorAll('.header__currency-option');

  currencyOptions.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const countryCode = button.dataset.value;
      const currencyCode = button.dataset.currency;

      if (!countryCode) return;

      console.log('Fallback: Currency clicked:', currencyCode, countryCode);

      // Find the form
      const form = button.closest('form');
      const input = form ? form.querySelector('input[name="country_code"]') : null;
      const label = form ? form.querySelector('.header__currency-label') : null;

      // Update hidden input
      if (input) {
        input.value = countryCode;
      }

      // Update label
      if (label && currencyCode) {
        label.textContent = currencyCode;
      }

      // Remove active class from all buttons
      const allButtons = document.querySelectorAll('.header__currency-option');
      allButtons.forEach((btn) => {
        btn.classList.remove('active');
      });

      // Add active class to clicked button
      button.classList.add('active');

      // Submit the form
      if (form) {
        form.submit();
      }
    });
  });
});
